import { action } from '@reatom/framework'
import i18next from 'i18next'

import { Result } from '@blade/std-lib'
import { Network, selectedNetworkAtom } from '@root/entities/network'
import { reatomRequest } from '@root/shared/lib'
import { showErrorSnackbarAction } from '@root/shared/ui'
import { showSnackbarAction } from '@root/shared/ui-kit'

import { importWalletTrackerRequestAction } from './wallet-tracker-requests'

import type { WalletAddress } from '@root/entities/wallet/model/WalletAddress'

const processAddWalletAction = action(
  async (
    ctx,
    {
      name,
      address,
      emoji,
      tags,
    }: {
      name: string
      address: WalletAddress
      emoji: string
      tags: Array<string>
    },
  ) => {
    const network = ctx.get(selectedNetworkAtom)
    const result = await ctx.schedule(() =>
      importWalletTrackerRequestAction(ctx, [
        {
          label: name,
          tags,
          emoji,
          network: Network.toDto(network),
          walletAddress: address,
          alertsEnabled: true,
        },
      ]),
    )
    return result
  },
  'processAddWalletAction',
)

export const reatomAddWalletTracker = () => {
  // eslint-disable-next-line @reatom/unit-naming-rule
  const requestState = reatomRequest({
    execAction: processAddWalletAction,
    onResult: (ctx, result) => {
      if (Result.isFailure(result)) {
        showErrorSnackbarAction(ctx, result.failure)
        return
      }
      walletTrackingAddedEvent(ctx)
      showSnackbarAction(ctx, {
        text: i18next.t('wallet-tracker.add-wallet.success'),
        intent: 'success',
      })
    },
  })

  return requestState
}

// eslint-disable-next-line @reatom/unit-naming-rule
export const walletTrackingAddedEvent = action<void>('walletTrackingAddedEvent')
